import { useEffect, useRef } from "react";
import { Check, FileText } from "lucide-react";
import type { ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";
import { ShiftFormEditor } from "../shift-production-form/ShiftFormEditor";
import { operatorDisplayName } from "../shift-production-form/operator-display-name";
import { statusLabel } from "./approval-presentation";
import { shiftLabels } from "../shift-production-form/line-options";

export function ApprovalFormPreview({ item, disabled, approved = false, showShift = true, onOpen }: {
  item: ShiftProductionFormListItem;
  disabled: boolean;
  approved?: boolean;
  showShift?: boolean;
  onOpen: (id: string) => void;
}) {
  const frameRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const frame = frameRef.current;
    if (!frame) return;
    const resize = () => frame.style.setProperty("--approval-preview-scale", String(frame.clientWidth / 1000));
    resize();
    const observer = new ResizeObserver(resize);
    observer.observe(frame);
    return () => observer.disconnect();
  }, []);
  const payload = item.previewPayload;
  const operatorName = operatorDisplayName(item.operatorName);
  return (
    <article className="approval-form-preview">
      {approved ? <div className="approval-form-preview-heading"><span>{statusLabel[item.status]}</span></div> : null}
      <div ref={frameRef} className="approval-form-preview-frame">
        {payload ? <div className="approval-form-preview-paper shift-approval-readonly" inert aria-hidden="true">
          <ShiftFormEditor
            readOnly readOnlyPayload={payload} actorName={payload.operatorName}
            form={null} selectionVersion={item.version} busy={false} error={null} notice={null}
            lineUnits={[]} lineUnitsError={null} onRetryLineUnits={() => undefined}
            documentSettings={{ documentNo: payload.documentNo, publicationDate: payload.publicationDate, revisionDate: payload.revisionDate, revisionNo: payload.revisionNo, version: item.version, updatedAt: item.updatedAt, updatedBy: null }}
            onSave={async () => null} onNew={() => undefined}
          />
        </div> : <div className="approval-form-preview-unavailable"><FileText size={28} aria-hidden="true" /><span>Önizleme alınamadı</span></div>}
        <button type="button" className="approval-form-preview-open" disabled={disabled} aria-label={`${item.formNo} formunu${approved ? " salt okunur" : ""} aç`} onClick={() => onOpen(item.id)} />
        {approved ? <span className="approval-form-preview-approved"><Check size={13} aria-hidden="true" />Onayladınız</span> : null}
      </div>
      <div className="approval-form-preview-caption">
        <span className="approval-form-preview-name" title={operatorName}>{operatorName}</span>
        {showShift ? <span>{item.shift ? shiftLabels[item.shift] : "—"}</span> : null}
        {item.revisionNumber > 1 ? <span>{item.revisionNumber} sürüm</span> : null}
      </div>
    </article>
  );
}
